'use client';

import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import styles from './AuthShell.module.scss';
import { Modal } from 'react-bootstrap';
import TermsAndConditions from '@/hotdesk-ui/terms-and-conditions/termsAndConditions';
import Image from 'next/image';
interface AuthFooterProps {
  termLink?: string;
  privacyPolicyLink?: string;
}
const AuthFooter: FC<AuthFooterProps> = ({
  termLink,
  privacyPolicyLink
}) => {
  const t = useTranslations();
  const [show, setShow] = useState(false);
  return <>
        <p className={styles.footer}>
            <a onClick={() => setShow(true)} rel="noopener noreferrer" className={styles.footerLink}>
                {t('footer.links.terms')}
            </a>{' '}
            {t('auth.and')}{' '}
            <a href={privacyPolicyLink || '#'} target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
                {t('footer.links.privacy')}
            </a>
        </p>
        <Modal show={show} onHide={() => setShow(false)} size="lg" data-sentry-element="Modal" data-sentry-source-file="AuthFooter.tsx">
            <Modal.Header closeButton className={styles.modalHeader} data-sentry-element="unknown" data-sentry-source-file="AuthFooter.tsx">
                <Modal.Title data-sentry-element="unknown" data-sentry-source-file="AuthFooter.tsx">
                    <div className={styles.termsAndConditions}>
                        <div className={styles.leftSection}>
                                <button type="button" className={styles.button} aria-haspopup="menu" aria-label={t('booking.bookingButton')}>
                                    <Image src="/assets/icons/termsncondition.svg" style={{
                  position: 'absolute'
                }} width={18} height={18} alt="termsncondition" className="mx-1 right-icon" data-sentry-element="Image" data-sentry-source-file="AuthFooter.tsx" />
                                </button>
                        </div>
                        <div className={styles.rightSection}>
                            <span className={styles.title}>{t('auth.termsAndConditions.title')}</span>
                            <span className={styles.subTitle}>{t('auth.termsAndConditions.subTitle')}</span>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className={styles.modalBody} data-sentry-element="unknown" data-sentry-source-file="AuthFooter.tsx">
            <TermsAndConditions mode="popup" onClose={() => setShow(false)} data-sentry-element="TermsAndConditions" data-sentry-source-file="AuthFooter.tsx" />
            </Modal.Body>
        </Modal>
        </>;
};
export default AuthFooter;